const mediaItems = [
  {
    title: '暗网入门：5分钟了解暗网是什么',
    desc: '用通俗易懂的方式讲解暗网、深网与表层网的区别，帮你快速建立暗网基础认知。',
    img: 'https://readdy.ai/api/search-image?query=Educational%20dark%20web%20introduction%20video%20thumbnail%20concept%2C%20dark%20charcoal%20background%20with%20warm%20amber%20play%20button%20and%20geometric%20patterns%2C%20minimalist%20tutorial%20aesthetic%2C%20clean%20knowledge%20sharing%20atmosphere%2C%20subtle%20gradient%20overlay%2C%20no%20text%2C%2016:9%20ratio&width=800&height=450&seq=media-intro-video&orientation=landscape',
    duration: '05:22',
  },
  {
    title: 'Tor浏览器安装配置实操演示',
    desc: '从下载到安全配置的全流程实操演示，跟着步骤一步步完成暗网访问环境搭建。',
    img: 'https://readdy.ai/api/search-image?query=Tor%20browser%20installation%20tutorial%20video%20thumbnail%2C%20dark%20background%20with%20warm%20copper%20screen%20elements%2C%20step%20by%20step%20guide%20aesthetic%2C%20minimalist%20tech%20tutorial%20composition%2C%20clean%20educational%20atmosphere%2C%20software%20setup%20visual%2C%20no%20text%2C%2016:9&width=800&height=450&seq=media-tor-setup&orientation=landscape',
    duration: '12:48',
  },
  {
    title: '暗网安全访问防护实战技巧',
    desc: '资深安全研究员分享暗网访问的实用安全防护经验，从VPN到PGP全覆盖。',
    img: 'https://readdy.ai/api/search-image?query=Security%20tips%20video%20thumbnail%20concept%2C%20dark%20background%20with%20crimson%20and%20amber%20shield%20patterns%2C%20cybersecurity%20expert%20talk%20aesthetic%2C%20minimalist%20protection%20visualization%2C%20clean%20atmospheric%20composition%2C%20lock%20and%20shield%20elements%2C%20no%20text%2C%2016:9&width=800&height=450&seq=media-security-tips&orientation=landscape',
    duration: '18:35',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          视频解说
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          图文不够直观？看视频一步步掌握暗网知识
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 border border-background-200/60 rounded-lg overflow-hidden transition-all duration-200"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200 cursor-pointer">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-background-950/30 group-hover:bg-background-950/20 transition-all duration-200 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/80 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-background-950/70 rounded text-[10px] font-medium text-foreground-300">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-100 mb-1.5 group-hover:text-primary-400 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}